import React from 'react';

// Reusable ChevronDown icon using CSS mask to control color without editing the SVG asset
const ChevronDownIcon: React.FC<React.HTMLAttributes<HTMLSpanElement>> = (props) => {
  const { style, ...rest } = props; // eslint-disable-line react/prop-types
  const size = 20;
  return (
    <span
      aria-hidden
      {...rest}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        backgroundColor: '#D7D7D7',
        WebkitMaskImage: 'url(/images/icons/Chevron-down.svg)',
        maskImage: 'url(/images/icons/Chevron-down.svg)',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        ...style,
      }}
    />
  );
};

// Variant for button icons - matches button text color
export const ChevronDownButtonIcon: React.FC<React.HTMLAttributes<HTMLSpanElement>> = (props) => {
  return (
    <ChevronDownIcon
      {...props}
      style={{
        width: 16,
        height: 16,
        backgroundColor: 'currentColor',
        ...props.style, // eslint-disable-line react/prop-types
      }}
    />
  );
};

export default ChevronDownIcon;
